// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.optimum-plan-page {
  padding: 20px 14% 40px;
}

.configure-plan,
.customer-info {
  margin-bottom: 25px 20px;
  border-radius: 20px;
  border: 2px solid #e0e0e0;
  background-color: #fefdfe;
}
.customer-info {
  padding: 20px;
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.section-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0 26px 0;
}

.customer-info-header {
  padding: 29px 0 15px 0;
}

h2 {
  font-size: 36px;
  font-weight: 500;
  color: #052456;
  margin: 0;
}

.optimun-plan {
  display: grid;
  grid-template-columns: repeat(6, 1fr);
  padding: 20px 0;
  row-gap: 20px;
}

.optimun-plan-item {
  padding-bottom: 20px;
  position: relative;
}

.optimun-plan-item:not(:nth-last-child(-n + 6)) {
  padding-bottom: 20px;
  border-bottom: 1px dashed #e0e0e0;
}

.optimun-plan-item:nth-last-child(-n + 6) {
  border-bottom: none;
}

.optimun-plan:first-child {
  border-top: none;
}

.optimun-plan-item {
  display: flex;
  flex-direction: column;
  padding: 0 20px;
}
.customer-info-item {
  display: flex;
  flex-direction: column;
}

.label {
  color: #19191980;
  font-size: 13px;
  font-weight: 500;
  margin-bottom: 10px;
}

.value {
  color: #191919;
  font-size: 14px;
  font-weight: 400;
  line-height: 30px;
  max-width: 260px;
  text-overflow: ellipsis;
}

.customer-details {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
  margin-top: 20px;
}

.customer-info-item {
  display: flex;
  justify-content: space-between;
}
.customer-info-item:nth-of-type(7) {
  height: 56px;
}
.customer-details-grid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: auto auto;
  gap: 35px 10px;
  align-items: start;
}

.bottom-section {
  background-color: #efefef;
  border-radius: 0 0 20px 20px;
  padding: 20px;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.view-cc {
  width: 137px;
  height: 32px;
  border-radius: 40px;
  border: 0;
  color: #ffffff;
  font-size: 13px;
  font-weight: 600;
  background-color: #f77c7c;
}

.button {
  width: 136px;
  height: 44px;
  border-radius: 40px;
  font-size: 16px;
  font-weight: 600;
}

.reject {
  border: 1px #191919 solid;
  color: #052456;
}

.accept {
  background-color: #60c57e;
  color: #ffffff;
  border: none;
}

.status-chip-details {
  display: flex;
  border: none;
  color: #ffffff;
  width: 80px;
  height: 26px;
  border-radius: 40px;
  font-size: 11px;
  font-weight: 400;
  align-items: center;
  justify-content: center;
  margin: 9px 0 0 11px;
}

.rejected {
  width: 120px;
}

.card_removed {
  width: 95px;
}

.rejected_ineligible {
  width: 170px;
}

.info-icon {
  margin: 9px 0 0 15px;
}

.header-panel {
  display: flex;
  justify-content: center;
  align-items: center;
}

.back-btn {
  transform: rotate(90deg);
  margin-top: 3px;
}

.previous-page {
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  margin: 10px 0 20px;
}

.previous-page p {
  font-size: 14px;
  font-weight: 500;
}

.view-cc.btn-diabled {
  opacity: 0.4;
  pointer-events: none;
}

.resend-btn {
  width: 96px;
  height: 32px;
  border-radius: 40px;
  font-size: 13px;
  font-weight: 600;
  line-height: 16px;
  text-align: center;
  background: #052456;
  color: var(--white);
  margin: 0 16px 0 16px;
}

.log-btn {
  min-width: 137px;
  color: #191919;
  border: #191919 1px solid;
  border-radius: 40px;
  font-size: 13px;
  font-weight: 600;
  height: 32px;
  background-color: #fff;
}

.tooltipContainer {
  margin-top: 12px;
  margin-left: 10px;
}

.customer-info-panel {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.customer-info-buttons {
  padding-top: 20px;
}

.rejected-tooltip {
  white-space: pre-wrap;
  max-width: 250px;
  display: block;
}

/* Responsive Styles */
@media (max-width: 768px) {
  .optimun-plan,
  .customer-details {
    grid-template-columns: 1fr;
  }

  .section-header {
    flex-direction: column;
    align-items: flex-start;
  }

  .buttons {
    margin-top: 10px;
  }

  .customer-details-full {
    grid-column: 1 / -1;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/customerServiceDashboard/customerServiceDashboard.css"],"names":[],"mappings":"AAAA;EACE,sBAAsB;AACxB;;AAEA;;EAEE,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,eAAe;EACf,aAAa;AACf;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,eAAe;AACjB;AACA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;AAChC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,6BAA6B;EAC7B,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,4BAA4B;EAC5B,aAAa;EACb,aAAa;EACb,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE;;IAEE,0BAA0B;EAC5B;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,mBAAmB;EACrB;AACF","sourcesContent":[".optimum-plan-page {\n  padding: 20px 14% 40px;\n}\n\n.configure-plan,\n.customer-info {\n  margin-bottom: 25px 20px;\n  border-radius: 20px;\n  border: 2px solid #e0e0e0;\n  background-color: #fefdfe;\n}\n.customer-info {\n  padding: 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n}\n\n.section-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 0 26px 0;\n}\n\n.customer-info-header {\n  padding: 29px 0 15px 0;\n}\n\nh2 {\n  font-size: 36px;\n  font-weight: 500;\n  color: #052456;\n  margin: 0;\n}\n\n.optimun-plan {\n  display: grid;\n  grid-template-columns: repeat(6, 1fr);\n  padding: 20px 0;\n  row-gap: 20px;\n}\n\n.optimun-plan-item {\n  padding-bottom: 20px;\n  position: relative;\n}\n\n.optimun-plan-item:not(:nth-last-child(-n + 6)) {\n  padding-bottom: 20px;\n  border-bottom: 1px dashed #e0e0e0;\n}\n\n.optimun-plan-item:nth-last-child(-n + 6) {\n  border-bottom: none;\n}\n\n.optimun-plan:first-child {\n  border-top: none;\n}\n\n.optimun-plan-item {\n  display: flex;\n  flex-direction: column;\n  padding: 0 20px;\n}\n.customer-info-item {\n  display: flex;\n  flex-direction: column;\n}\n\n.label {\n  color: #19191980;\n  font-size: 13px;\n  font-weight: 500;\n  margin-bottom: 10px;\n}\n\n.value {\n  color: #191919;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 30px;\n  max-width: 260px;\n  text-overflow: ellipsis;\n}\n\n.customer-details {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n  margin-top: 20px;\n}\n\n.customer-info-item {\n  display: flex;\n  justify-content: space-between;\n}\n.customer-info-item:nth-of-type(7) {\n  height: 56px;\n}\n.customer-details-grid {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-template-rows: auto auto;\n  gap: 35px 10px;\n  align-items: start;\n}\n\n.bottom-section {\n  background-color: #efefef;\n  border-radius: 0 0 20px 20px;\n  padding: 20px;\n  display: flex;\n  justify-content: flex-end;\n  gap: 10px;\n}\n\n.view-cc {\n  width: 137px;\n  height: 32px;\n  border-radius: 40px;\n  border: 0;\n  color: #ffffff;\n  font-size: 13px;\n  font-weight: 600;\n  background-color: #f77c7c;\n}\n\n.button {\n  width: 136px;\n  height: 44px;\n  border-radius: 40px;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.reject {\n  border: 1px #191919 solid;\n  color: #052456;\n}\n\n.accept {\n  background-color: #60c57e;\n  color: #ffffff;\n  border: none;\n}\n\n.status-chip-details {\n  display: flex;\n  border: none;\n  color: #ffffff;\n  width: 80px;\n  height: 26px;\n  border-radius: 40px;\n  font-size: 11px;\n  font-weight: 400;\n  align-items: center;\n  justify-content: center;\n  margin: 9px 0 0 11px;\n}\n\n.rejected {\n  width: 120px;\n}\n\n.card_removed {\n  width: 95px;\n}\n\n.rejected_ineligible {\n  width: 170px;\n}\n\n.info-icon {\n  margin: 9px 0 0 15px;\n}\n\n.header-panel {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.back-btn {\n  transform: rotate(90deg);\n  margin-top: 3px;\n}\n\n.previous-page {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  cursor: pointer;\n  margin: 10px 0 20px;\n}\n\n.previous-page p {\n  font-size: 14px;\n  font-weight: 500;\n}\n\n.view-cc.btn-diabled {\n  opacity: 0.4;\n  pointer-events: none;\n}\n\n.resend-btn {\n  width: 96px;\n  height: 32px;\n  border-radius: 40px;\n  font-size: 13px;\n  font-weight: 600;\n  line-height: 16px;\n  text-align: center;\n  background: #052456;\n  color: var(--white);\n  margin: 0 16px 0 16px;\n}\n\n.log-btn {\n  min-width: 137px;\n  color: #191919;\n  border: #191919 1px solid;\n  border-radius: 40px;\n  font-size: 13px;\n  font-weight: 600;\n  height: 32px;\n  background-color: #fff;\n}\n\n.tooltipContainer {\n  margin-top: 12px;\n  margin-left: 10px;\n}\n\n.customer-info-panel {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.customer-info-buttons {\n  padding-top: 20px;\n}\n\n.rejected-tooltip {\n  white-space: pre-wrap;\n  max-width: 250px;\n  display: block;\n}\n\n/* Responsive Styles */\n@media (max-width: 768px) {\n  .optimun-plan,\n  .customer-details {\n    grid-template-columns: 1fr;\n  }\n\n  .section-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n\n  .buttons {\n    margin-top: 10px;\n  }\n\n  .customer-details-full {\n    grid-column: 1 / -1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
